import React, { Component } from "react";
import PropTypes from "prop-types";

import { Link } from "react-router-dom";
import { connect } from "react-redux";
import { Container, Col, Row, Button } from "react-bootstrap";
import FacebookLogin from "react-facebook-login";

import BaseView from "./BaseView";
import {
  authGoogle,
  authFacebook,
} from "../common/redux/actions/AuthenticationActions";
import EmailUsernameLoginForm from "./EmailUsernameLoginForm";
import Divider from "../components/Divider";
import HeroImage from "../components/HeroImage";
import {
  getErrorMessage,
  getHeroImage,
  getTitleImage,
} from "../common/utilities/utilities";

class LoginView extends Component {
  // Declare tokenClient as a class property
  tokenClient = null;

  componentDidMount() {
    const clientId = process.env.REACT_APP_GOOGLE_CLIENT_ID;

    if (!clientId) {
      console.warn(
        "Google Client ID is missing. Google Identity Services will not be initialized.",
      );
      return;
    }

    // Initialize the Google Identity Services Token Client
    // This replaces window.gapi.load and window.gapi.auth2.init
    if (window.google && window.google.accounts && window.google.accounts.oauth2) {
      this.tokenClient = window.google.accounts.oauth2.initTokenClient({
        client_id: clientId,
        scope: 'https://www.googleapis.com/auth/userinfo.profile https://www.googleapis.com/auth/userinfo.email', // Add the scopes your app needs, e.g., email, profile
        callback: (tokenResponse) => {
          // This callback is executed when the access token is received
          if (tokenResponse.access_token) {
            this.responseGoogle(tokenResponse.access_token);
          } else {
            console.error('Failed to get access token:', tokenResponse);
          }
        },
        error_callback: (error) => {
          console.error('GIS token client error:', error);
          this.onSignInFailure(error); // Use your existing failure handler
        }
      });
      console.log("Google Identity Services Token Client initialized successfully");
    } else {
      console.error("Google Identity Services script is not loaded correctly.");
    }
  }

  onSignInFailure = (error) => {
    // This method can now handle errors from the GIS token client
    console.error("Google Sign-In Error:", error);
    // You might want to display a user-friendly error message here
  };

  handleGoogleLogin = () => {
    if (this.tokenClient) {
      this.tokenClient.requestAccessToken(); // Request the access token
    } else {
      console.error("Google Token Client is not initialized.");
      // Optionally, inform the user or try to re-initialize
    }
  };

  handleTestGoogle = () => {
    this.props.authGoogle("JS", process.env.REACT_APP_TEST_GOOGLE_TOKEN);
  };

  handleTestFacebook = () => {
    this.props.authFacebook("JS", process.env.REACT_APP_TEST_FACEBOOK_TOKEN);
  };

  responseGoogle = (accessToken) => {
    // This function now directly receives the access token
    this.props.authGoogle("JS", accessToken);
  };

  responseFacebook = (response) => {
    this.props.authFacebook("JS", response.accessToken);
  };

  render() {
    return (
      <BaseView title={this.context.t("Login")} backurl="/">
        <Container fluid={true} style={{ padding: 0 }}>
          <HeroImage height="180px" imageURL={getHeroImage()}>
            <img
              src={getTitleImage()}
              alt=""
              style={{ width: 200, marginTop: "-12px" }}
            />
          </HeroImage>
          <Container style={{ marginTop: "-130px" }}>
            <Row className="mt-2">
              <Col>
                <FacebookLogin
                  textButton={this.context.t("Continue with Facebook")}
                  appId={process.env.REACT_APP_FACEBOOK_CLIENT_ID}
                  fields="name, email"
                  icon="fa-facebook fa-lg"
                  cssClass="facebook-button button-modified"
                  callback={this.responseFacebook}
                  onFailure={this.responseFacebookFailure}
                  isMobile={false}
                />
              </Col>
            </Row>
            <Row className="mt-3">
              <Col>
                <button
                  type="button"
                  className="login-with-google-btn-new button-modified"
                  onClick={this.handleGoogleLogin} // This triggers the GIS flow
                >
                  {this.context.t("Continue with Google")}
                </button>
              </Col>
            </Row>
            <Divider text={this.context.t("or")} className="mt-4" />
            <Row className="mt-3">
              <Col>
                <EmailUsernameLoginForm />
              </Col>
            </Row>
            <Row className="mt-3">
              <Col>
                {this.props.login_error && (
                  <p style={{ color: "red" }}>
                    {getErrorMessage(
                      this.props.login_error.message,
                      this.context,
                    )}
                  </p>
                )}
                {this.props.signup_error && (
                  <p style={{ color: "red" }}>
                    {getErrorMessage(
                      this.props.signup_error.message,
                      this.context,
                    )}
                  </p>
                )}
              </Col>
            </Row>
            <Row className="mt-3">
              <Col>
                <Link to="/" style={{ color: "white" }}>
                  {this.context.t("Continue Browse as guest")}
                </Link>
              </Col>
            </Row>
            <Divider text={this.context.t("or")} className="mt-4" />
            <Row>
              <Link to="/registration/jobseeker">
                <p>{this.context.t("New to golden dreams?")}</p>
                <Button className="btn btn-primary gd-button button-modified">
                  {this.context.t("Click here to register")}
                </Button>
              </Link>
            </Row>
          </Container>
        </Container>
      </BaseView>
    );
  }
}

LoginView.contextTypes = {
  t: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => {
  return {
    lang: state.i18nState.lang,
    login_error: state.AuthenticationState.errors.login,
    signup_error: state.AuthenticationState.errors.signup,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    authGoogle: (type, access_token) =>
      dispatch(authGoogle(type, access_token)),
    authFacebook: (type, access_token) =>
      dispatch(authFacebook(type, access_token)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(LoginView);